import loadable from '@loadable/component';

export const MergerBannerLoadable = loadable(() => import('./MergerBanner'), {
  resolveComponent: (module) => module.MergerBanner,
});
